// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1ad83ab3","239":"e0d75032","453":"80863eb3","732":"acfe918c"}[chunkId] + ".chunk.js";
};